import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Modal } from 'nallian-shared-ui/lib/components';
import { GetMyPrincipal } from 'nallian-shared-ui/lib/selectors';
import OverviewText from '../../home/components/OverviewText';

const CommunityInfoModal = ({ open, onClose, community }) => {
  const { t } = useTranslation();
  const myPrincipal = useSelector(GetMyPrincipal);
  const language = myPrincipal?.languageId || 'en';

  if (!open) return null;

  return (
    <Modal open closeIcon onClose={onClose} size="small">
      <Modal.Header>
        {community?.name} {t('community')}
      </Modal.Header>
      <Modal.Content>
        <OverviewText tag={community?.tag} language={language} name={myPrincipal?.fullName} />
      </Modal.Content>
    </Modal>
  );
};

CommunityInfoModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  community: PropTypes.shape({
    tag: PropTypes.string,
    name: PropTypes.string,
  }),
};

CommunityInfoModal.defaultProps = {
  community: null,
};

export default CommunityInfoModal;
